$(function(){

  const propArray = [
    ['刺繍の大きさ', 'ProductSelectedSize'],
    ['刺繍のフォント', 'ProductSelectedFont'],
    ['刺繍の位置', 'ProductSelectedPosition'],
    ['刺繍の色', 'ProductSelectedColor'],
    ['刺繍する文字-1行目', 'ProductSelectedLetter1'],
    ['刺繍する文字-2行目', 'ProductSelectedLetter2']
  ];

  const propLetterText = ['文字数 1〜5', '文字数 6〜10', '文字数 11〜15'];

  // 「刺繍サービス」の商品IDと金額
  // IDはajaxでカートに入れるときに使うので絶対に合わせる
  // 金額はサイトに表示するのに使う。カートでは管理画面で設定している金額が出ます。
  const stitchData = [
    [
      {
        id: '39435120279657',
        price: 385
      },
      {
        id: '39435120312425',
        price: 660
      },
      {
        id: '39435120345193',
        price: 908
      }
    ],
    [
      {
        id: '39435120377961',
        price: 440
      },
      {
        id: '39435120410729',
        price: 770
      },
      {
        id: '39435120443497',
        price: 1073
      }
    ]
  ];

  const formatter = new Intl.NumberFormat('ja-JP');

  let isAnySet = false, isAllSet = false;
  let sizeIndex = null, letterIndex = null, sizeId = null;

  let letterMaxNum = 15;
  let productFlg = null;
  if( myProductTitle.indexOf('FACE') !== -1 ||  myProductTitle.indexOf('WASH') !== -1 ){
    productFlg = 0;
  }
  else if( myProductTitle.indexOf('BATH TOWEL') !== -1 ){
    productFlg = 1;
  }
  else if( myProductTitle.indexOf('SHEET') !== -1 ){
    productFlg = 2;
  }


  // イニシャライズ
  _setProp();


  // イベント
  $('.js-stitch-open-btn').on('click', function(e){
    e.preventDefault();
    document.body.classList.add('stitch-modal-open');
  });

  $('.js-stitch-close-btn').on('click', function(e){
    e.preventDefault();
    document.body.classList.remove('stitch-modal-open');

    _setProp();
  });

  $('.stitchmodal').on('click', function(e){
    e.preventDefault();
    document.body.classList.remove('stitch-modal-open');

    _setProp();
  });

  $('.js-stitch-decision-btn').on('click', function(e){
    e.preventDefault();
    document.body.classList.remove('stitch-modal-open');

    _setProp();
  });

  $('.stitchmodal-inner').on('click', function(e){
    e.stopPropagation();
  });

  $('.js-stitch-clear-btn').on('click', function(e){
    e.preventDefault();
    _clearProp();
  });

  $('.stitchmodal-content input').on('change', function(){
    _checkProp();
  });

  // 刺繍の大きさの選択肢に沿って、刺繍する文字入力欄のキャプションを切り替える
  $('[name="properties[刺繍の大きさ]"]').on('change', function(){
    let $checked = $('[name="properties[刺繍の大きさ]"]:checked');
    sizeIndex = $checked.data('index');

    $('.stitchmodal-list-letter-caption > div').hide();
    $('.stitchmodal-list-letter-caption > div').eq(sizeIndex).show();

    $('.stitchmodal-letter-field').val('');

    if( sizeIndex == 1 ){
      $('.stitchmodal-list-letter-selector p').eq(1).hide();
      $('.stitchmodal-letter-field').attr('maxlength', 5);
    }
    else {
      $('.stitchmodal-list-letter-selector p').eq(1).show();
      $('.stitchmodal-letter-field').attr('maxlength', 7);
    }

  });

  // 刺繍する文字に入力された文字数で、金額を切り替える
  $('.stitchmodal-letter-field').on('input change', function(){
    let letterValue = $('[name="properties[刺繍する文字-1行目]"]').val() + $('[name="properties[刺繍する文字-2行目]"]').val();
    let count = letterValue.length;

    if( count > letterMaxNum ){
      $(this).val( $(this).val().slice(0,-1) );
      letterValue.slice(0,-1);
      count = letterMaxNum;
    }

	if( 0 < count && count<=5 ){
      letterIndex = 0;
    }
    else if( 5 < count && count<=10 ){
      letterIndex = 1;
    }
    else if( 10 < count && count<=15 ){
      letterIndex = 2;
    }
    else {
      letterIndex = null;
    }

    $('.stitchmodal-list-letter-caption > div:visible span').removeClass('selected');
    $('.stitchmodal-list-letter-caption > div:visible span').eq(letterIndex).addClass('selected');
  });

  // カートに入れるボタンを押したとき
  // ajaxで「刺繍サービス」をカートに入れる
  $('[data-submit-button]').on('click', function(e){
	e.preventDefault();

    if( isAllSet ){
      let stitchdata = _getSizeProp(sizeIndex, letterIndex);
      let sizeId = stitchdata['id'];
      let quantity = $('input#Quantity').val();

      let submitData = {};

      submitData['刺繍するタオル'] = myProductTitle;
      submitData['HEM COLOR'] = $('[name=id]:checked').data('color-text');

      for( let i=0; i < propArray.length; i++ ){
        if( $('[name="properties['+propArray[i][0]+']"]').attr('type') == 'radio' ){
         if( $('[name="properties['+propArray[i][0]+']"]:checked').prop('checked') ){
           submitData[propArray[i][0]] = $('[name="properties['+propArray[i][0]+']"]:checked').val();
         }
        }
        else if( $('[name="properties['+propArray[i][0]+']"]').attr('type') == 'text' ){
          submitData[propArray[i][0]] = $('[name="properties['+propArray[i][0]+']"]').val();
        }
      }

      $.post('/cart/add.js', {
        items: [
          {
            quantity: quantity,
            id: sizeId,
            properties: submitData
          }
        ]
      })
      .always(function(){
        _clearProp();

        // undefinedにするために削除する
        // でないとオプションとして送信されてしまう
        _removeTextField();
                                         
        $('.shopify-product-form').submit();
      });
    }
    else {
      _clearProp();
        _removeTextField();
      $('.shopify-product-form').submit();
    }
  });

  // オプションがどれだけ設定されているか調べる
  // すべて選択されている／どれか選択されているのフラグ
  function _checkProp(prop){
	let isLetterSet = false;
	if( $('[name="properties[刺繍する文字-1行目]"]').val() || $('[name="properties[刺繍する文字-2行目]"]').val() ){ isLetterSet = true; }

    if(
      $('[name="properties[刺繍の大きさ]"]:checked').prop('checked')
      && $('[name="properties[刺繍のフォント]"]:checked').prop('checked')
      && $('[name="properties[刺繍の位置]"]:checked').prop('checked')
      && $('[name="properties[刺繍の色]"]:checked').prop('checked')
      && isLetterSet
    ){ isAllSet = true; }
    else { isAllSet = false; }

    if(
      $('[name="properties[刺繍の大きさ]"]:checked').prop('checked')
      || $('[name="properties[刺繍のフォント]"]:checked').prop('checked')
      || $('[name="properties[刺繍の位置]"]:checked').prop('checked')
      || $('[name="properties[刺繍の色]"]:checked').prop('checked')
      || isLetterSet
    ){ isAnySet = true; }
    else { isAnySet = false; }

    if( isAllSet ){ $('.stitchmodal-submit').removeClass('off'); }
    else { $('.stitchmodal-submit').addClass('off'); }
  }

  function _getSizeProp(size, letter){
    return stitchData[size][letter];
  }

  function _setProp(){
	_checkProp();
    _toggleStitchList();

	if( isAllSet ){
      for( let i = 0; i < propArray.length; i++ ){
        if( $('[name="properties['+propArray[i][0]+']"]').attr('type') == 'radio' ){
         if( $('[name="properties['+propArray[i][0]+']"]:checked').prop('checked') ){
          $('#'+propArray[i][1]).text( $('[name="properties['+propArray[i][0]+']"]:checked').val() );
         }
        }
        else if( $('[name="properties['+propArray[i][0]+']"]').attr('type') == 'text' ){
          $('#'+propArray[i][1]).text( $('[name="properties['+propArray[i][0]+']"]').val() );
        }
      }
	}
                                           
    if( sizeIndex != null && letterIndex != null ){
      // 文字数を表示
      $('#ProductSelectedLetter').text( propLetterText[letterIndex] );
                                           
      // 価格を表示
      let stitchdata = _getSizeProp(sizeIndex, letterIndex);
      let price = stitchdata['price'];

      $('#ProductStitchPrice').text('¥'+formatter.format(price));

      let totalprice = price + myProductPrice; 
      $('#ProductStitchTotalPrice').text('¥'+formatter.format(totalprice)+'(tax included)');                                      
    }
  }
                                           
  function _toggleStitchList(){
    if( isAllSet ){
      $('#ProductContents').addClass('is-set-stitch');
    }
    else {
      $('#ProductContents').removeClass('is-set-stitch');
    }                   
  }

  function _clearProp(){
    $('#ProductContents').removeClass('is-set-stitch');
                                           
	for( let i = 0; i < propArray.length; i++ ){
      if( $('[name="properties['+propArray[i][0]+']"]').attr('type') == 'radio' ){
        $('[name="properties['+propArray[i][0]+']"]:checked').prop('checked', false);
      }
      else if( $('[name="properties['+propArray[i][0]+']"]').attr('type') == 'text' ){
        $('[name="properties['+propArray[i][0]+']"]').val(null);
      }

      $('#'+propArray[i][1]).text('');
    }

    $('.stitchmodal-list-letter-caption > div').hide();
    $('.stitchmodal-list-letter-caption > div span').removeClass('selected');

    sizeIndex = null;
    letterIndex = null;

    _checkProp();
  }
                                         
  function _removeTextField(){
    $('[name="properties[刺繍する文字-1行目]"]').remove();
    $('[name="properties[刺繍する文字-2行目]"]').remove();
    $('[name="properties[文字数]"]').remove();
  }

});